import { useOutletContext } from 'react-router-dom'
import { HOME_ROUTE } from '../../../app/router/routes'
import { useAppSelector } from '../../../app/store/store'
import { FEATURES, hasFeatureGrant } from '../../../entities/my'
import { studentService } from '../../../entities/student'
import { StudentsWidget } from '../../../widgets/students'
import { AccessDeniedRedirect } from '../../../shared/ui/accessDeniedRedirect'


export default function StudentsPage() {

    const {my} = useAppSelector(s => s.myReducer)

    const trigger: boolean = useOutletContext()

    const canListStudents = hasFeatureGrant(my, FEATURES.STUDENTS.LIST)
    const canViewStudentsFull = hasFeatureGrant(my, FEATURES.STUDENTS.VIEW_FULL)
    const canViewStudentsTutor = hasFeatureGrant(my, FEATURES.STUDENTS.VIEW_TUTOR)

    if(!canListStudents || (!canViewStudentsFull && !canViewStudentsTutor)){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    const request = my.role === 'tutor'
        ? () => studentService.getAllByTutorUserId(my.id)
        : studentService.getAll

    const filterRequest = my.role === 'tutor'
        ? (workTgIds: number[], isLost: boolean, paymentIds: number[], labels: string[], tagIds: number[]) => studentService.getAllByTutorFilters(my.id, workTgIds, isLost, undefined, paymentIds, labels, tagIds)
        : undefined

    return (
        <StudentsWidget 
            request={request}
            filterRequest={filterRequest}
            filtersEnabled={my.role !== 'tutor'}
            triggerReq={trigger}
            highlight={canViewStudentsFull}
            forceServerFilter={my.role !== 'tutor'}
        />
    )
}
